module.exports = __webpack_public_path__ + "static/media/arrow_drop_down-24px.65605f0a.svg";